import { useEffect, useState } from "react";
import styles from "./price.module.css";
import RangeSlider from "../../../shared/slider/RangeSlider";
import { HeadingTitle } from "../../../shared/index";

const PriceFilter = ({
  min,
  max,
  heading,
  filtersProps,
  filtersActions,
}) => {
  const { priceRange } = filtersProps;
  const { setPriceRange } = filtersActions;

  // LOCAL UI STATE
  const [localPrice, setLocalPrice] = useState(priceRange);

  // Sync external updates
  useEffect(() => {
    setLocalPrice(priceRange);
  }, [priceRange]);

  // DEBOUNCE API UPDATE
  useEffect(() => {
    const timer = setTimeout(() => {
      setPriceRange(localPrice);
    }, 400);

    return () => clearTimeout(timer);
  }, [localPrice, setPriceRange]);

  return (
    <>
      <HeadingTitle
        text={heading || ""}
        style={styles.sectionTitle}
      />

      <div className={styles.priceRangeWrapper}>
        <RangeSlider
          price={localPrice}
          setPrice={setLocalPrice}
          min={min}
          max={max}
        />

        <div className={styles.priceDisplay}>
          Price: ₹{localPrice[0]} - ₹{localPrice[1]}
        </div>
      </div>
    </>
  );
};

export default PriceFilter;